var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"calc(100vh - 165px)"}},[_c('b-spinner',{staticClass:"align-middle"})],1):_c('custom-entity-table',{attrs:{"default-search-field":_vm.defaultSearchField,"custom-service":_vm.service,"custom-entity":_vm.customEntity}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }